var figure = $(".video").hover(hoverVideo, hideVideo);

function hoverVideo(e) {
    $('video', this).get(0).play();
}

function hideVideo(e) {
    $('video', this).get(0).pause();
}

$(document).ready(function () {
    let menu = document.querySelector("div:not(.chatbox-popup) .js-menu");
    let start_y = window.scrollY;
    if(menu) {
        menu.addEventListener("click", ev => {
            start_y = window.scrollY;
        });
        window.addEventListener("scroll", ev => {
            if (!menu.classList.contains("active") && (Math.abs(window.scrollY - start_y) > 400)) {
                menu.click();
            }
        }, {passive: true});
    }
});


// Custom slider
let slider = document.querySelector('.image-slider');
if (slider) {
    let dragging = false;
    let hovering = false;
    let clickFlag = true;
    let initX;
    let step = slider.getBoundingClientRect().width + 64;
    console.log(step);
    let slides = slider.querySelectorAll('.slide');
    let min = (step - 1) * slides.length * -1;

    slider.addEventListener('mousedown', function(e) {
        dragging = true;
        initX = e.clientX;
    })
    slider.addEventListener('mouseup', function(e) {
        if (!clickFlag) {
            dragging = false;
            // Snap to slide
            let stop = parseFloat(window.getComputedStyle(slider).transform.split(',')[4]);
            let closest = step;
            let position = -32;
            let stopPos = 0;
            for (let i = -1 ; i < slider.children.length ; i++) {
                if (Math.abs(position - stop) < Math.abs(closest - stop)) {
                    closest = position;
                    stopPos = i + 2;
                }
                position -= step;
            }
            if (stopPos == 0) {
                if (slider.querySelector('.active')) {
                    slider.querySelector('.active').classList.remove('active');
                }
                slides[slider.children.length - 1].classList.add('active');
                closest = step * -1 * (slider.children.length - 1);
                slider.setAttribute("style", `transform: translate(${closest}px,0);`);
                slider.classList.add('transition2');
                setTimeout(function() {
                    clickFlag = true;
                    slider.classList.remove('transition2');
                }, 1000);
            }
            else if (stopPos == slider.children.length + 1) {
                if (slider.querySelector('.active')) {
                    slider.querySelector('.active').classList.remove('active');
                }
                slides[0].classList.add('active');
                closest = 0;
                slider.setAttribute("style", `transform: translate(${closest}px,0);`);
                slider.classList.add('transition2');
                setTimeout(function() {
                    clickFlag = true;
                    slider.classList.remove('transition2');
                }, 1000);
            }
            else {
                if (slider.querySelector('.active')) {
                    slider.querySelector('.active').classList.remove('active');
                }
                slides[stopPos - 1].classList.add('active');
                slider.setAttribute("style", `transform: translate(${closest}px,0);`);
                slider.classList.add('transition');
                setTimeout(function() {
                    clickFlag = true;
                    slider.classList.remove('transition');
                }, 250);
            }
        }
    })
    window.addEventListener('mousemove', function(e) {
        if (dragging) {
            clickFlag = false;
            let offset = e.clientX - initX;
            initX = e.clientX;
            let initial = parseFloat(window.getComputedStyle(slider).transform.split(',')[4]);
            slider.setAttribute("style", `transform: translate(${initial + offset}px,0);`);
        }
    })

    for (let i = 0 ; i < slides.length ; i++) {
        slides[i].addEventListener('mouseup', function(e) {
            if (clickFlag) {
                dragging = false;
                if (slider.querySelector('.active')) {
                    slider.querySelector('.active').classList = 'slide';
                }
                slides[i].classList = 'slide active';
                slider.setAttribute("style", `transform: translate(${step * i * -1}px,0);`);
                slider.classList.add('transition');
                setTimeout(function() {
                    slider.classList.remove('transition');
                }, 250);
            }
        })
        slides[i].addEventListener('mouseenter', function(e) {
            if (!slides[i].classList.contains('active')) {
                if (slides[i].previousElementSibling) {
                    if (slides[i].previousElementSibling.classList.contains('active')) {
                        slides[i].classList = 'slide arrow-right';
                    }
                    else {
                        slides[i].classList = 'slide arrow-left';
                    }
                }
                else {
                    slides[i].classList = 'slide arrow-left';
                }
            }
        })
    }

    window.addEventListener('resize', function() {
        let prevPos = parseFloat(slider.getAttribute("style").split('(')[1].split(',')[0]) / step;
        step = slider.getBoundingClientRect().width + 64;
        slider.setAttribute("style", `transform: translate(${step * prevPos}px,0);`);
    })
}

let gslider = document.querySelector('.gear-slider');
if (gslider) {
    let hoverflag = false;
    let step = gslider.parentElement.getBoundingClientRect().width
    gslider.addEventListener('mouseenter', function(e) {
        hoverflag = true;
    })
    gslider.addEventListener('mouseleave', function(e) {
        hoverflag = false;
    })
    window.addEventListener('mousemove', function(e) {
        if (hoverflag) {
            let split = gslider.parentElement.getBoundingClientRect().x + gslider.parentElement.getBoundingClientRect().width / 2;
            if (e.clientX < split) {
                gslider.classList = "gear-slider arrow-left";
            }
            else {
                gslider.classList = "gear-slider arrow-right";
            }
        }
    })
    gslider.addEventListener('click', function(e) {
        let dir = gslider.classList[1];
        let width = gslider.parentElement.getBoundingClientRect().width;
        let min = width * gslider.children.length * -1;
        if (dir == "arrow-right") {
            // Forwards
            let prevX = parseFloat(gslider.getAttribute("style").split(',')[0].split('(')[1]);
            if (prevX - width > min) {
                gslider.setAttribute('style', `transform: translate(${prevX - width}px, 0)`);
            }
            else {
                gslider.setAttribute('style', `transform: translate(0px, 0)`);
            }
        }
        else {
            // Backwards
            let prevX = parseFloat(gslider.getAttribute("style").split(',')[0].split('(')[1]);
            if (prevX + width <= 0) {
                gslider.setAttribute('style', `transform: translate(${prevX + width}px, 0)`);
            }
            else {
                gslider.setAttribute('style', `transform: translate(${min + width}px, 0)`);
            }
        }
    })
    window.addEventListener('resize', function() {
        let prevPos = parseFloat(gslider.getAttribute("style").split('(')[1].split(',')[0]) / step;
        step = gslider.parentElement.getBoundingClientRect().width;
        console.log(step);
        gslider.setAttribute("style", `transform: translate(${step * prevPos}px,0);`);
    })
}



AOS.init({
    duration: 1200
});


// Chatbox popup
(function(){
    const cookieValue = document.cookie.indexOf('show_chatbox=')
    console.log(cookieValue)
    if(cookieValue < 0){
    // if (!document.referrer.includes('hdg-architecture.com') && !document.referrer.includes('localhost:1935')) {
        const chatbox = document.querySelector('.chatbox-popup');
        if(chatbox){
            chatbox.classList.add('show');

            const closeBtn = chatbox.querySelector('.close-btn');
            closeBtn.addEventListener('click', function(){
                chatbox.classList.remove('show');
            });

            // setTimeout(function(e) {
            //     chatbox.classList.add('show');
            // }, 9800)
        }
        // localStorage.setItem('popup-closed', 'true');
        var now = new Date();
        now.setDate( now.getDate() + 1)
        document.cookie = "expires=" + now.toUTCString() + ";"
        document.cookie = "show_chatbox=" + true;
    }
})();

